<script>
	import formatNumber from "../utils/formatNumber";

	export let data;

	export let onmousemove = null;
	export let onmouseout = null;
	export let max = undefined;
	export let min = undefined;
	export let spotRadius = 2;
	export let strokeWidth = 2;
	export let height = 30;
	export let interactive = !!onmousemove;
	export let title
	export let property
	export let digits = 0
	export let units = ''

	let svg;

	$: spotDiameter = spotRadius / 2;
	$: {
		if (svg && data && data[property]) {
			update(data[property], svg)
		} else if (svg) {
			update([], svg)
		}
	}

	function update(values) {
		removeChildren(svg);

		const localMax = max == null ? Math.max(...values) : max;
		const localMin = min == null ? Math.min(...values) : min;

		if (!values || !values.length) return

		// The rendering width will account for the spot size.
		const width =
			parseFloat(
				svg.getBoundingClientRect().width || parseInt(svg.attributes.width)
			) -
			spotDiameter * 2;

		// Get the SVG element's full height.
		// This is used
		const fullHeight = parseFloat(height);

		// The rendering height accounts for stroke width and spot size.
		const localHeight = fullHeight - strokeWidth * 2 - spotDiameter;

		// Some arbitrary value to remove the cursor and spot out of
		// the viewing canvas.
		const offscreen = -1000;

		// Cache the last item index.
		const lastItemIndex = values.length - 1;

		// Calculate the X coord base step.
		const offset = width / lastItemIndex;

		// Hold all datapoints, which is whatever we got as the entry plus
		// x/y coords and the index.
		const datapoints = [];

		// Hold the line coordinates.
		const pathY = getY(
			localMax,
			localMin,
			localHeight,
			strokeWidth + spotRadius,
			values[0]
		);
		let pathCoords = `M${spotDiameter} ${pathY}`;

		values.forEach((value, index) => {
			const x = index * offset + spotDiameter;
			const y = getY(
				localMax,
				localMin,
				localHeight,
				strokeWidth + spotRadius,
				value
			);

			// datapoints.push(Object.assign({}, entries[index], {
			//   index: index,
			//   x: x,
			//   y: y
			// }));

			pathCoords += ` L ${x} ${y}`;
		});

		const path = buildElement("path", {
			class: "sparkline--line",
			d: pathCoords,
			fill: "none",
		});

		let fillCoords = `${pathCoords} V ${fullHeight} L ${spotDiameter} ${fullHeight} Z`;

		const fill = buildElement("path", {
			class: "sparkline--fill",
			d: fillCoords,
			stroke: "none",
		});

		svg.appendChild(fill);
		svg.appendChild(path);

		if (!interactive) {
			return;
		}

		const cursor = buildElement("line", {
			class: "sparkline--cursor",
			x1: offscreen,
			x2: offscreen,
			y1: 0,
			y2: fullHeight,
			"stroke-width": cursorWidth,
		});

		const spot = buildElement("circle", {
			class: "sparkline--spot",
			cx: offscreen,
			cy: offscreen,
			r: spotRadius,
		});

		svg.appendChild(cursor);
		svg.appendChild(spot);

		const interactionLayer = buildElement("rect", {
			width: svg.attributes.width.value,
			height: svg.attributes.height.value,
			style: "fill: transparent; stroke: transparent",
			class: "sparkline--interaction-layer",
		});
		svg.appendChild(interactionLayer);

		interactionLayer.addEventListener("mouseout", (event) => {
			cursor.setAttribute("x1", offscreen);
			cursor.setAttribute("x2", offscreen);

			spot.setAttribute("cx", offscreen);

			if (onmouseout) {
				onmouseout(event);
			}
		});

		interactionLayer.addEventListener("mousemove", (event) => {
			const mouseX = event.offsetX;

			let nextDataPoint = datapoints.find((entry) => {
				return entry.x >= mouseX;
			});

			if (!nextDataPoint) {
				nextDataPoint = datapoints[lastItemIndex];
			}

			let previousDataPoint = datapoints[datapoints.indexOf(nextDataPoint) - 1];
			let currentDataPoint;
			let halfway;

			if (previousDataPoint) {
				halfway =
					previousDataPoint.x + (nextDataPoint.x - previousDataPoint.x) / 2;
				currentDataPoint =
					mouseX >= halfway ? nextDataPoint : previousDataPoint;
			} else {
				currentDataPoint = nextDataPoint;
			}

			const x = currentDataPoint.x;
			const y = currentDataPoint.y;

			spot.setAttribute("cx", x);
			spot.setAttribute("cy", y);

			cursor.setAttribute("x1", x);
			cursor.setAttribute("x2", x);

			if (onmousemove) {
				onmousemove(event, currentDataPoint);
			}
		});
	}

	function getY(max, min, height, diff, value) {
		const factor = height / (max - min || 2);
		return parseFloat((max - value) * factor + diff).toFixed(2);
	}

	function buildElement(tag, attrs) {
		const element = document.createElementNS("http://www.w3.org/2000/svg", tag);

		for (let name in attrs) {
			element.setAttribute(name, attrs[name]);
		}

		return element;
	}

	function removeChildren(svg) {
		[...svg.querySelectorAll("*")].forEach((element) =>
			svg.removeChild(element)
		);
	}

	function getLast(values) {
		if (!values || !values.length) return
		return values[values.length - 1]
	}
</script>

{#if data}
	<div class="infoLine">
		{#if units}
			<div>{title} ({units})</div>
		{:else}
			<div>{title}</div>
		{/if}
		<div>{formatNumber(getLast(data[property]), digits)}</div>
		<svg style={`stroke-width: ${strokeWidth};`} bind:this={svg} {height} />
	</div>
{/if}


<style>
	.infoLine {
		display:grid;
		background:white;
		border:1px solid lightgray;
		border-radius: 0.5rem;
		padding:0.5rem;
		margin:0.2rem;
		color: gray;
		flex-wrap:wrap;
		grid-template-columns: 1fr auto;
	}
	/* line with highlight area */
	svg {
		grid-row: 2;
		grid-column: 1 / span 2;
		stroke: blue;
		fill: rgba(0, 0, 255, 0.1);
		width: 100%;
	}
</style>